import React from "react";
import { Instagram, Facebook, Linkedin, Youtube, MessageCircle } from "lucide-react";
import { CONTACT, waLink, NAV } from "@/data/site";
import { Marquee } from "@/components/pp/Shared";
import { scrollTo } from "@/components/pp/Navbar";
import { track } from "@/lib/api";

const serviceLinks = ["Social Media", "Branding", "Video Production", "Performance Ads", "SEO", "Web Development"];
const companyLinks = [
  { label: "About", id: "about" }, { label: "Work", id: "work" }, { label: "Pricing", id: "pricing" },
  { label: "Process", id: "process" }, { label: "Team", id: "team" }, { label: "Contact", id: "contact" },
];
const legalLinks = ["Privacy Policy", "Terms and Conditions", "Refund / Cancellation Policy"];

export default function Footer() {
  return (
    <footer className="relative bg-[#050507] border-t border-white/10 pt-20 pb-32 md:pb-12" data-testid="footer">
      <Marquee text="PIXELS WITH PURPOSE" className="opacity-60" />

      <div className="pp-container grid grid-cols-2 md:grid-cols-12 gap-10 mt-12">
        <div className="col-span-2 md:col-span-4">
          <img src="/brand/logo-dark.png" alt="PixelPapad" className="h-9 mb-5" />
          <p className="text-sm text-slate-400 leading-relaxed max-w-xs">
            PixelPapad is a creative marketing & digital growth agency — branding, social, content, performance and immersive web, under one roof.
          </p>
          <div className="flex gap-3 mt-6">
            {[{ I: Instagram, k: "instagram" }, { I: Facebook, k: "facebook" }, { I: Linkedin, k: "linkedin" }, { I: Youtube, k: "youtube" }].map(({ I, k }) => (
              <a key={k} href={CONTACT.socials[k]} target="_blank" rel="noopener noreferrer" aria-label={k}
                className="h-9 w-9 grid place-items-center rounded-full border border-white/10 text-slate-400 hover:text-[#f59e0b] hover:border-[#f59e0b]/40 transition-colors"><I size={16} /></a>
            ))}
            <a href={waLink()} target="_blank" rel="noopener noreferrer" onClick={() => track("whatsapp_click", { location: "footer" })}
              className="h-9 w-9 grid place-items-center rounded-full border border-white/10 text-[#25D366] hover:border-[#25D366]/40 transition-colors" aria-label="WhatsApp"><MessageCircle size={16} /></a>
          </div>
        </div>

        <div className="md:col-span-2">
          <p className="pp-overline mb-4">Services</p>
          <ul className="space-y-2.5">
            {serviceLinks.map((s) => <li key={s}><button onClick={() => scrollTo("services")} className="text-sm text-slate-400 hover:text-white transition-colors">{s}</button></li>)}
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="pp-overline mb-4">Company</p>
          <ul className="space-y-2.5">
            {companyLinks.map((c) => <li key={c.id}><button onClick={() => scrollTo(c.id)} className="text-sm text-slate-400 hover:text-white transition-colors">{c.label}</button></li>)}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="pp-overline mb-4">Get in touch</p>
          <a href={`tel:${CONTACT.phone}`} className="block text-sm text-slate-300 hover:text-[#f59e0b]">{CONTACT.phone}</a>
          <a href={`mailto:${CONTACT.email}`} className="block text-sm text-slate-300 hover:text-[#f59e0b] mt-1">{CONTACT.email}</a>
          <a href={`https://${CONTACT.website}`} target="_blank" rel="noopener noreferrer" className="block text-sm text-slate-300 hover:text-[#f59e0b] mt-1">{CONTACT.website}</a>
          <p className="text-sm text-slate-500 mt-3">{CONTACT.address}</p>
          <ul className="flex flex-wrap gap-x-4 gap-y-1 mt-5">
            {legalLinks.map((l) => <li key={l}><a href="#" className="text-xs text-slate-500 hover:text-white transition-colors">{l}</a></li>)}
          </ul>
        </div>
      </div>

      <div className="pp-container mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-display uppercase tracking-widest text-[#f59e0b] text-sm">Pixels With Purpose.</p>
        <p className="text-xs text-slate-500">© {new Date().getFullYear()} PixelPapad. All rights reserved.</p>
      </div>
    </footer>
  );
}
